export function hasTouch() {
  return 'ontouchstart' in window;
}

export function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
}
